import { render, staticRenderFns } from "./tutorials.vue?vue&type=template&id=682bd570&scoped=true&"
import script from "./tutorials.vue?vue&type=script&lang=js&"
export * from "./tutorials.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "682bd570",
  null
  
)

export default component.exports